import {cs}            from "@Common/react/chain-services";
import {fragments}     from "@Common/react/fragments";
import {Invoke}        from "@Common/react/invoke";
import {TimeoutAction} from "@Common/react/timeout-action";
import {UseState}      from "@Common/react/use-state";

export const AutoSave = ({active, save, next}) => cs(
    ["state", (_, next) => UseState({next})],

    ({state}) => fragments(
        next({
            saving: !!state.value,
        }),

        active && !state.value && TimeoutAction({
            delay: 10,
            action: () => state.onChange(true),
        }),

        active && state.value && Invoke({
            action: async () => {
                await save();
                state.onChange(false);
            },
        }),

    ),
);
